<app-dialog
  [title]="data.title"
  [actions]="actions"
  (action)="action($event)"
  (close)="close()"
>
<div class="py-3" *ngIf="(!data.isShowPrepBy && !data.isShowBoxSource && !data.isShipmentName && !data.isShipingPrice) || data.isdeductFrom">
    <label class="input-container_label">Select Warehouse:</label>
    <mat-form-field class="custom-mat-select">
    <mat-select   class="input-container_input input-container_input--select"  disableOptionCentering  [formControl]="fromWareHouseId">
        <mat-select-trigger>
         <span> {{fromWareHouseId.value?.id}} <small class="whAddress-text">({{fromWareHouseId.value?.city}} {{fromWareHouseId.value?.state}}) </small>  </span>
        </mat-select-trigger>
        <mat-option *ngFor="let warehouse of data.warehouse" [value]="warehouse">
          {{ warehouse.id }} <small class="whAddress-text">({{warehouse.city}},{{warehouse.state}})</small></mat-option>
      </mat-select>
    </mat-form-field>
</div>

<div class="py-3" *ngIf="data.isShowBoxSource">
  <label class="input-container_label">Select Source:</label>
  <mat-form-field class="custom-mat-select">
  <mat-select class="input-container_input input-container_input--select"  disableOptionCentering  [formControl]="boxContentSource">
    <mat-option value="FEED"> Feed </mat-option>
    <mat-option value="2D_BARCODE"> 2D Barcodes </mat-option>
    <mat-option value="NONE"> None (Skip Box Info) </mat-option>
    </mat-select>
  </mat-form-field> 
</div>

<div class="py-3" *ngIf="data.isShowPrepBy">
  <label class="input-container_label">Select Prep By:</label>
  <mat-form-field class="custom-mat-select">
  <mat-select   class="input-container_input input-container_input--select"  disableOptionCentering  [formControl]="prepBy">
      <mat-option value="seller"> Seller </mat-option>
      <mat-option value="amazon"> Amazon </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="py-3" *ngIf="data.isShipmentName"> 
  <div class="input-container">
    <label class="input-container_label">Shipment Name</label>
    <input type="text" class="input-container_input" [formControl]="shipmentName" />
  </div>
</div>
<div class="py-3" *ngIf="data.isShipingPrice"> 
  <div class="input-container">
    <label class="input-container_label">Shipping Price</label>
    <input type="number" class="input-container_input" [formControl]="shipingPrice" />
  </div>
</div>
</app-dialog>
